export default function Welcome() {
	return (
		<div style={{ height: "70vh", display: "flex", justifyContent: "center", alignItems: "center" }}>
			<h1>Welcome to LynkID</h1>
		</div>
	);
}
